<template>
    <div>
        <input type="file" 
            class="form-control" 
            :id="id" 
            accept="image/*"
            @change="handleChange" />
        <img v-if="preview" :src="preview" class="img-responsive" style="max-height: 100px;" />
    </div>
</template>

<script>
export default {
    created() {
        this.preview = this.initialPreview
    },
    data() {
        return {
            preview: null,
        }
    },
    methods: {
        handleChange(event) {
            let file = event.target.files[0],
                fileReader = new FileReader();

            fileReader.onload = (event) => {
                this.preview = event.target.result;
            }

            fileReader.readAsDataURL(file);
            this.$emit('change', file);
        }
    },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        initialPreview: {
            type: String,
            required: false,
            default: null,
        },
    },
}
</script>